import React, {useState} from 'react';
import {Button, Popover, Select, Tree} from 'antd';
import {DataNode} from 'antd/lib/tree';
import {ArticleCatalogsTreeData} from '../../pages/manage/articleList';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {ArticleApi} from '../../scaffold';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function CopyArticleBtn(props: {id: number; refresh: () => any}) {
  const [catalogs, _catalogs] = useState('最新公告');
  const copyHook = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleCopyPost);
  function copy() {
    copyHook
      .request({
        copyArticleParams: {
          id: props.id,
          catalogs: catalogs,
        },
      })
      .then(() => {
        props.refresh();
      })
      .catch(CommonApiErrorHandler);
  }
  return (
    <>
      <Popover
        title={'复制文章'}
        content={
          <div>
            <Tree className={'ArticleCatalogsTree'} showLine onSelect={(keys, info) => _catalogs(keys[0] as string)} treeData={ArticleCatalogsTreeData} />
            <Button type={'primary'} className={'m-t-5'} onClick={copy} loading={copyHook.loading}>
              确定复制
            </Button>
          </div>
        }>
        <a>复制文章</a>
      </Popover>
    </>
  );
}
